module.exports = __webpack_public_path__ + "img/pen-leather.698a4d92.svg";